import { z } from 'zod';
import { PASSWORD_POLICY_REGEX, PASSWORD_POLICY_MESSAGE } from '../constants/password-policy';

/**
 * Zod Schemas for Auth forms
 */
export const loginSchema = z.object({
  email: z
    .string()
    .min(1, 'E-mail é obrigatório')
    .email('E-mail inválido'),
  password: z
    .string()
    .min(8, 'Senha deve ter no mínimo 8 caracteres'),
  /**
   * Tenant resolvido pelo hostname (via /branding). Hidden field,
   * incluído pelo formulário quando presente. Cross-validado server-side.
   */
  tenantId: z.string().uuid().optional(),
});

export type LoginFormData = z.infer<typeof loginSchema>;

export const forgotPasswordSchema = z.object({
  email: z
    .string()
    .min(1, 'E-mail é obrigatório')
    .email('E-mail inválido'),
  /** Tenant resolvido pelo hostname (cross-validado server-side). */
  tenantId: z.string().uuid().optional(),
});

export type ForgotPasswordFormData = z.infer<typeof forgotPasswordSchema>;

export const resetPasswordBaseSchema = z.object({
  token: z.string().min(1, 'Token é obrigatório'),
  newPassword: z
    .string()
    .min(8, 'Senha deve ter no mínimo 8 caracteres')
    .regex(PASSWORD_POLICY_REGEX, PASSWORD_POLICY_MESSAGE),
  confirmPassword: z.string().min(1, 'Confirmação de senha é obrigatória'),
});

export const resetPasswordSchema = resetPasswordBaseSchema.refine(
  (data) => data.newPassword === data.confirmPassword,
  { message: 'Senhas não coincidem', path: ['confirmPassword'] },
);

export type ResetPasswordFormData = z.infer<typeof resetPasswordSchema>;

export const changePasswordSchema = z.object({
  currentPassword: z.string().min(1, 'Senha atual é obrigatória'),
  newPassword: z
    .string()
    .min(8, 'Nova senha deve ter no mínimo 8 caracteres')
    .regex(PASSWORD_POLICY_REGEX, PASSWORD_POLICY_MESSAGE),
  confirmPassword: z.string().min(1, 'Confirmação de senha é obrigatória'),
}).refine((data) => data.newPassword === data.confirmPassword, {
  message: 'Senhas não coincidem',
  path: ['confirmPassword'],
});

export type ChangePasswordFormData = z.infer<typeof changePasswordSchema>;
